import PaymentMethodDatalayer from '@curry/payment-method'

export default class PaymentMethodsApi {
  constructor({ config, transports }) {
    this.datalayer = new PaymentMethodDatalayer({ config, transports });
  }

  get({ orderId, cashOnly = true }) {
    return new Promise((resolve, reject) => {
      const args = { order_id: orderId };
      this.datalayer.models[0].find({ args }).then((response) => {
        let ret = [];

        if(cashOnly) {
          response.data.forEach((paymentMethod) => {
            if(paymentMethod.slug === 'cash') {
              ret.push(paymentMethod);
            }
          });
        } else {
          ret = response.data;
        }
        
        resolve(ret);
      }).catch(reject);
    });
  }

  post({ orderId, method }) {
    return new Promise((resolve, reject) => {
      const args = { order_id: orderId };
      this.datalayer.models[0].save({ args, item: { payment_method: method } }).then((response) => {
        resolve(response.data);
      }).catch(reject);
    });
  }
}